import { render, staticRenderFns } from "./listBtn.vue?vue&type=template&id=3638f139&"
import script from "./listBtn.vue?vue&type=script&lang=js&"
export * from "./listBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports